import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

// It's a shameless wordle clone
ReactDOM.render(
  <App />,
  document.getElementById('root')
);
